import React from 'react';
import { authRoles } from 'app/auth';

export const SettingsConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	// Open to every authenticated role. AdminUserSettings hides the
	// admin-only tabs (Users, Settings, Administration, Advanced) for
	// non-admins; the My Secrets tab is shown to everyone. The deep
	// link /settings/my-secrets opens directly to that tab regardless
	// of role.
	auth: authRoles.anyAuthenticated,
	routes: [
		// More specific routes must come before the generic :section? route
		{
			path: '/settings/storage/providers',
			component: React.lazy(() => import('./storage/StorageProvidersPage'))
		},
		{
			path: '/settings/storage/policies',
			component: React.lazy(() => import('./storage/StoragePoliciesPage'))
		},
		{
			path: '/settings/storage/shared',
			component: React.lazy(() => import('./storage/SharedStoragePage'))
		},
		{
			path: '/settings/:section?',
			component: React.lazy(() => import('./AdminUserSettings'))
		}
	]
};

export const SettingsUser = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.user,
	excludeAuth: authRoles.participant,
	routes: [
		{
			path: '/settings_user',
			component: React.lazy(() => import('./BasicUserSettings'))
		}
	]
};

